<script lang="ts">
  import CloseIcon from './CloseIcon.svelte'
</script>

<button class="selected-item" type="button" on:click>
  <span class="mr-2"><slot /></span>
  <CloseIcon />
</button>
